"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
require("../jss"); // eslint-disable-line import/no-unassigned-import
var theme_1 = __importDefault(require("../theme"));
var deepmerge_1 = __importDefault(require("deepmerge"));
require("@policygenius/mortar-core/dist/mortar-core.scss"); // eslint-disable-line import/no-unassigned-import
var Provider = function (_a) {
    var children = _a.children, overrides = _a.overrides;
    var _theme = overrides ? (0, deepmerge_1.default)(theme_1.default, overrides) : theme_1.default;
    return react_1.default.createElement(react_jss_1.ThemeProvider, { theme: _theme }, children);
};
exports.default = Provider;
